import React from "react";
import { FaFacebook, FaTwitter, FaLinkedin, FaEnvelope } from "react-icons/fa";
import logo from "../assets/images/logo.png";

const Footer = () => {
  return (
    <footer className="pt-16 pb-10 px-6">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-5 gap-12">
        {/* Logo & Description */}
        <div>
          <img src={logo} alt="TruPay Logo" className="h-18 mb-4" />
          <p className="text-sm">
            Powering smarter payments for modern businesses.
          </p>
        </div>

        {/* Company Links */}
        <div>
          <h4 className="font-semibold mb-4">Company</h4>
          <ul className="space-y-2 text-sm">
            <li>
              <a href="#">About</a>
            </li>
            <li>
              <a href="#">Careers</a>
            </li>
            <li>
              <a href="#">Press</a>
            </li>
            <li>
              <a href="#">Blog</a>
            </li>
          </ul>
        </div>

        {/* Product Links */}
        <div>
          <h4 className="font-semibold mb-4">Product</h4>
          <ul className="space-y-2 text-sm">
            <li>
              <a href="#">Features</a>
            </li>
            <li>
              <a href="#">Pricing</a>
            </li>
            <li>
              <a href="#">Integrations</a>
            </li>
            <li>
              <a href="#">Status</a>
            </li>
          </ul>
        </div>

        {/* Newsletter + Socials (All in one column) */}
        <div className="flex flex-col justify-between md:col-span-2">
          {/* Newsletter */}
          <div className="mb-6">
            <h4 className="font-semibold mb-4">Subscribe to our newsletter</h4>
            <form className="relative max-w-xs w-full">
              <input
                type="email"
                placeholder="Your email"
                className="w-full pl-4 pr-14 py-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-teal-500 text-sm text-gray-800"
              />
              <button
                type="submit"
                className="absolute top-1/2 -translate-y-1/2 right-1 bg-teal-500 p-2 rounded-md hover:bg-teal-600 transition text-white"
              >
                <FaEnvelope />
              </button>
            </form>
          </div>

          {/* Follow Us */}
          <div>
            <h4 className="font-semibold mb-4">Follow Us</h4>
            <div className="flex gap-4 text-xl">
              <a href="#">
                <FaFacebook className="text-teal-500" />
              </a>
              <a href="#">
                <FaTwitter className="text-teal-500" />
              </a>
              <a href="#">
                <FaLinkedin className="text-teal-500" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <hr className="border-grey-100 border-1 max-w-7xl mx-auto mt-12" />

      <div className="mt-12 text-center text-sm">
        © {new Date().getFullYear()} TruPay. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
